import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const BANNER_STORE_NAME = 'banner'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
